import React from 'react';
import CabCrudPage from './CabCrudPage';
import { uploadAdminAsset } from '../../../api/cabsHomepageAdmin';

const AdminCabsBlogs = () => (
  <CabCrudPage
    title="Blogs"
    description="Manage blog posts shown on the public site."
    resource="blogs"
    uploadHandler={uploadAdminAsset}
    enableReorder
    defaultItem={{
      title: '',
      slug: '',
      coverImageUrl: '',
      excerpt: '',
      content: '',
      publishedAt: '',
      sortOrder: 0,
      isActive: true,
    }}
    columns={[
      { key: 'title', label: 'Title' },
      { key: 'slug', label: 'Slug' },
      { key: 'publishedAt', label: 'Published' },
    ]}
    fields={[
      { name: 'title', label: 'Title', required: true },
      { name: 'slug', label: 'Slug', required: true },
      { name: 'coverImageUrl', label: 'Cover image', type: 'image', required: true },
      { name: 'excerpt', label: 'Excerpt', type: 'textarea', rows: 3 },
      { name: 'content', label: 'Content (Markdown)', type: 'markdown', rows: 8, required: true, col: 'col-12' },
      { name: 'publishedAt', label: 'Published at', type: 'date' },
      { name: 'sortOrder', label: 'Sort order', type: 'number' },
      { name: 'isActive', label: 'Active', type: 'checkbox', col: 'col-md-6' },
    ]}
  />
);

export default AdminCabsBlogs;
